import AddIcon from '@mui/icons-material/Add'
import {Button} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {useKilnConfig} from '../../../providers'
import {KilnConfigActionType} from '../../../types'

export const AddStationButton: React.FC = () => {
  const {t} = useTranslation()
  const {dispatch} = useKilnConfig()

  return (
    <Button
      variant="outlined"
      color="secondary"
      onClick={() => dispatch({type: KilnConfigActionType.ADD_STATION})}
      startIcon={<AddIcon />}
      sx={{border: '1px solid #E8ECF0', height: ({spacing}) => spacing(6)}}
      data-test-id="add-station-btn"
    >
      {t('kilnConfig.addStation')}
    </Button>
  )
}
